export default __webpack_public_path__ + "static/media/cashflow-img.bf18f778.svg";